export default class {
    constructor(store) {
        this.store = store;
        this.modules = {};
    }
    add(moduleName, moduleData) {
        this.modules[moduleName] = { namespaced: true, ...moduleData };
    }
    register(moduleName, initialState = {}) {
        this.modules[moduleName].state = {
            ...this.modules[moduleName].state,
            ...initialState,
        };
        this.store.registerModule(moduleName, this.modules[moduleName]);
    }
    getStore() {
        return this.store;
    }
}
